<template>
    <div>
        <h4>Etape 1 - Campagne Google Ads</h4>
        <b-form-group>
            <div>
                <label> Nom de la campagne : </label>
                <b-form-input v-model="campaign.name" type="text" />
            </div>
            <div class="mt-1">
                <label> Budget par jour de la campagne(en €) : </label>
                <b-form-input v-model="campaign.budget" type="number" />
            </div>
            <div class="mt-1">
                <label> CPC max : </label>
                <b-form-input v-model="campaign.cpcMax" type="number" />
            </div>
            <!-- <div cols="6" class="d-flex align-items-center flex-wrap mt-1">
                <b-alert show class="mr-1 mb-1 flex-grow-1 m-0 text-center" style="padding: 10px">{{ logoName }}</b-alert>
                <b-btn variant="primary" style="padding: 10px; margin-bottom: 15px" @click="openLogoSelection()">
                    <feather-icon icon="UploadIcon" />
                    Importer le logo
                </b-btn>
                <b-form-file ref="fileInput" v-model="campaign.logo" class="d-none" accept=".png, .jpeg, .jpg"></b-form-file>
            </div> -->

            <b-button class="mt-2 float-right" variant="primary" @click="$emit('next')" :disabled="disableNextBtn"> Suivant </b-button>
        </b-form-group>
    </div>
</template>
<script>
    export default {
        props: {
            campaign: {
                type: Object,
            },
        },
        data() {
            return {};
        },
        computed: {
            // logoName() {
            //     const logo = this.campaign.logo;
            //     if (logo) {
            //         const filetype = logo.type.split('/')[1];
            //         return logo.name.length > 15 ? logo.name.slice(0, 14) + `...${filetype}` : logo.name;
            //     }
            //     return 'Aucun logo importé';
            // },
            disableNextBtn() {
                let disable = false;
                for (const data in this.campaign) {
                    if (!this.campaign[data] && data != 'logo') {
                        disable = true;
                    }
                }
                return disable;
            },
        },
        // methods: {
        //     openLogoSelection() {
        //         this.$refs.fileInput.$el.childNodes[0].click();
        //     },
        // },
    };
</script>
